// import React, { useState } from "react";
// import Card from "components/card";
// import { MdClose } from "react-icons/md";
// import { FaPlane } from "react-icons/fa";

// const FlightModal = ({ isOpen, onClose, onAdd, editingItem }) => {
//   const [formData, setFormData] = useState({
//     name: "",
//     route: "",
//     time: "",
//     price: "",
//     departureDate: ""
//   });

//   React.useEffect(() => {
//     if (editingItem) {
//       setFormData({
//         name: editingItem.name || "",
//         route: editingItem.route || "",
//         time: editingItem.time || "",
//         price: editingItem.price || "",
//         departureDate: editingItem.departureDate || ""
//       });
//     } else {
//       setFormData({ name: "", route: "", time: "", price: "", departureDate: "" });
//     }
//   }, [editingItem, isOpen]);

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     onAdd(formData);
//     setFormData({ name: "", route: "", time: "", price: "", departureDate: "" });
//     onClose();
    
//     // Trigger auto-save by dispatching custom event
//     setTimeout(() => {
//       window.dispatchEvent(new CustomEvent('cartesUpdated'));
//     }, 600);
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
//       <Card extra="w-[500px] max-h-[90vh] overflow-y-auto">
//         <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-6 rounded-t-[20px]">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center space-x-3">
//               <div className="rounded-full bg-white p-2">
//                 <FaPlane className="h-6 w-6 text-blue-500" />
//               </div>
//               <h3 className="text-2xl font-bold text-white">{editingItem ? 'Edit Flight Details' : 'Add Flight Details'}</h3>
//             </div>
//             <button onClick={onClose} className="rounded-full bg-white/20 p-2 text-white hover:bg-white/30">
//               <MdClose className="h-6 w-6" />
//             </button>
//           </div>
//         </div>
        
//         <form onSubmit={handleSubmit} className="p-6 space-y-6">
          
          
//           <div>
//             <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Route</label>
//             <input
//               type="text"
//               placeholder="e.g., JFK → LAX"
//               value={formData.route}
//               onChange={(e) => setFormData({...formData, route: e.target.value})}
//               className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-blue-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
//               required
//             />
//           </div>
          
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div>
//               <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Departure Date</label>
//               <input
//                 type="date"
//                 value={formData.departureDate}
//                 onChange={(e) => setFormData({...formData, departureDate: e.target.value})}
//                 className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-blue-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
//                 required
//               />
//             </div>
//             <div>
//               <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Departure & Arrival Time</label>
//               <input
//                 type="text"
//                 placeholder="e.g., 10:30 AM - 2:45 PM"
//                 value={formData.time}
//                 onChange={(e) => setFormData({...formData, time: e.target.value})}
//                 className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-blue-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
//                 required
//               />
//             </div>
//           </div>
          
//           <div className="flex space-x-4 pt-4">
//             <button
//               type="submit"
//               className="flex-1 rounded-xl bg-gradient-to-r from-blue-500 to-blue-600 py-3 px-6 text-white font-semibold hover:from-blue-600 hover:to-blue-700 transform hover:scale-105 transition-all duration-200 shadow-lg"
//             >
// {editingItem ? 'Update Flight' : 'Add Flight'}
//             </button>
//             <button
//               type="button"
//               onClick={onClose}
//               className="flex-1 rounded-xl bg-gray-100 py-3 px-6 text-gray-700 font-semibold hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 dark:hover:bg-gray-600 transition-colors"
//             >
//               Cancel
//             </button>
//           </div>
//         </form>
//       </Card>
//     </div>
//   );
// };

// export default FlightModal;
import React, { useState, useEffect } from "react";
import Card from "components/card";
import { MdClose } from "react-icons/md";
import { FaPlane } from "react-icons/fa";

// Dummy flight list
const dummyFlights = [
  { id: 1, name: "Delta Airlines", route: "JFK → LAX", time: "10:30 AM - 2:45 PM", price: "350" },
  { id: 2, name: "United Airlines", route: "JFK → LAX", time: "12:00 PM - 4:15 PM", price: "380" },
  { id: 3, name: "American Airlines", route: "JFK → LAX", time: "3:00 PM - 7:15 PM", price: "400" },
];

const FlightModal = ({ isOpen, onClose, onAdd, editingItem }) => {
  const [formData, setFormData] = useState({
    route: "",
    departureDate: "",
    time: ""
  });

  const [availableFlights, setAvailableFlights] = useState([]);
  const [selectedFlight, setSelectedFlight] = useState(null);
  const [searching, setSearching] = useState(false);

  // Helper to format today's date for input[type=date]
  const getTodayDate = () => {
    const d = new Date();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${d.getFullYear()}-${month}-${day}`;
  };

  useEffect(() => {
    if (editingItem) {
      setFormData({
        route: editingItem.route || "",
        departureDate: editingItem.departureDate || getTodayDate(),
        time: editingItem.time || ""
      });
      setSelectedFlight(editingItem);
    } else {
      setFormData({
        route: "",
        departureDate: getTodayDate(),
        time: ""
      });
      setSelectedFlight(null);
    }
    setAvailableFlights([]);
  }, [editingItem, isOpen]);

  const handleSearch = () => {
    setSearching(true);
    setTimeout(() => {
      // Always show dummy flights
      setAvailableFlights(dummyFlights);
      setSearching(false);
    }, 500);
  };

  const handleSelectFlight = (flight) => {
    setSelectedFlight(flight);
  };

  const handleSubmit = () => {
    if (!selectedFlight) {
      alert("Please select a flight first");
      return;
    }
    const finalData = { ...formData, ...selectedFlight };
    onAdd(finalData);
    onClose();

    // Trigger auto-save event
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent("cartesUpdated"));
    }, 600);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-60 backdrop-blur-sm">
      <Card extra="w-[500px] max-h-[90vh] overflow-y-auto">
        <div className="bg-gradient-to-r from-blue-500 to-blue-600 p-6 rounded-t-[20px]">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="rounded-full bg-white p-2">
                <FaPlane className="h-6 w-6 text-blue-500" />
              </div>
              <h3 className="text-2xl font-bold text-white">{editingItem ? 'Edit Flight Details' : 'Add Flight Details'}</h3>
            </div>
            <button onClick={onClose} className="rounded-full bg-white/20 p-2 text-white hover:bg-white/30">
              <MdClose className="h-6 w-6" />
            </button>
          </div>
        </div>

        <div className="p-6 space-y-4">
          {/* Search Form */}
          <div>
            <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Route</label>
            <input
              type="text"
              placeholder="e.g., JFK → LAX"
              value={formData.route}
              onChange={(e) => setFormData({ ...formData, route: e.target.value })}
              className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-blue-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Departure Date</label>
              <input
                type="date"
                value={formData.departureDate}
                onChange={(e) => setFormData({ ...formData, departureDate: e.target.value })}
                className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-blue-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
              />
            </div>
            <div>
              <label className="block text-sm font-semibold text-navy-700 dark:text-white mb-2">Departure & Arrival Time</label>
              <input
                type="text"
                placeholder="e.g., 10:30 AM - 2:45 PM"
                value={formData.time}
                onChange={(e) => setFormData({ ...formData, time: e.target.value })}
                className="w-full rounded-xl border-2 border-gray-200 p-3 focus:border-blue-500 focus:outline-none dark:border-gray-600 dark:bg-navy-800 dark:text-white transition-colors"
              />
            </div>
          </div>

          <button
            onClick={handleSearch}
            disabled={searching}
            className="w-full bg-blue-500 text-white py-3 rounded-xl font-semibold hover:bg-blue-600 transition-colors"
          >
            {searching ? "Searching..." : "Search Flights"}
          </button>

          {/* Flight list */}
          {availableFlights.length > 0 && (
            <div className="mt-4 space-y-2 max-h-64 overflow-y-auto">
              {availableFlights.map(flight => (
                <div
                  key={flight.id}
                  onClick={() => handleSelectFlight(flight)}
                  className={`p-3 border rounded-xl cursor-pointer flex justify-between items-center ${
                    selectedFlight?.id === flight.id ? 'border-blue-500 bg-blue-50' : 'border-gray-200 hover:bg-gray-100'
                  }`}
                >
                  <div>
                    <p className="font-semibold">{flight.name}</p>
                    <p className="text-sm text-gray-500">{flight.route} - {flight.time}</p>
                  </div>
                  <p className="font-semibold">${flight.price}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="p-6 flex gap-4">
          <button
            onClick={handleSubmit}
            disabled={!selectedFlight}
            className="flex-1 bg-gradient-to-r from-blue-500 to-blue-600 text-white py-3 rounded-xl font-semibold hover:from-blue-600 hover:to-blue-700 transform hover:scale-105 transition-all duration-200 disabled:opacity-50"
          >
            {editingItem ? 'Update Flight' : 'Add Flight'}
          </button>
          <button
            onClick={onClose}
            className="flex-1 bg-gray-100 py-3 rounded-xl font-semibold hover:bg-gray-200 transition-colors"
          >
            Cancel
          </button>
        </div>
      </Card>
    </div>
  );
};

export default FlightModal;
